import { logLocation } from '@ringcentral/rwc-utils/src/rwc-logger';
import { removeQueryParamFromURL } from '@ringcentral/rwc-utils/src/url';

/**
 * Removes query parameter(s) from current location using history
 */
export const removeFromQuery = (key: string | Array<string>, replaceHistory: boolean): void => {
    const newurl = removeQueryParamFromURL(key, location.href);
    if (newurl !== location.href) {
        history[replaceHistory ? 'replaceState' : 'pushState']({ path: newurl }, '', newurl);

        logLocation?.();
    }
};
